const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const saleDeletedChanges = require('./saleDeleted-fullcont-changes')
const saleDeletedEmailTracking = require('./saleDeleted-email-tracking')
const saleDeletedDialog = require('./saleDeleted-dialog')
const websocket = require('../../../../../js-network/web-socket')
const saleDeletedDt = require('./saleDeleted-dt')

export let inventoryStock = []

let saleDeletedHtmlFc = null
let restoringSale = false

export function initDataFc(htmlFc) {
  saleDeletedHtmlFc = htmlFc
}

export function getDataFc() {
  return saleDeletedHtmlFc
}

export function dtgenerator(result, htmlFc) {
  const dtBody = htmlFc.fullcontHTML.querySelector('#saleDeleted-changes')
  if (!dtBody) return

  dtBody.innerHTML = ''
  const changes = result?.entitychanges?.[0]?.data
  if (!Array.isArray(changes) || !changes.length || !changes[0]?.user_name) return

  dtBody.insertAdjacentHTML('beforeend', saleDeletedChanges.organizeRowEntityChange(changes))
}

export function emailTrackingGenerator(result, htmlFc) {
  saleDeletedEmailTracking.render(result, htmlFc.fullcontHTML)
}

export function showcost(htmlFc) {
  const root = htmlFc.fullcontHTML
  const visible = Boolean(root.querySelector('#showcost')?.checked)

  root.querySelector('#col_showcost')?.classList.toggle('dn', !visible)
  root.querySelector('#title_return')?.classList.toggle('dn', !visible)
  root.querySelector('#saleDeleted_form_total_profit_pct')?.parentNode?.classList.toggle('dn', !visible)

  const main = root.querySelector('#cont_main')
  const detail = root.querySelector('#cont_detail')
  if (main) main.style.width = visible ? '25%' : '48%'
  if (detail) detail.style.width = visible ? '73%' : '50%'

  root.querySelectorAll('#cont_detail label').forEach(label => {
    const column = label.parentNode
    if (column.classList.contains('title_qty')) {
      column.classList.toggle('c14', visible)
      column.classList.toggle('c25', !visible)
    } else if (!column.classList.contains('title_cost')) {
      column.classList.toggle('c20', visible)
      column.classList.toggle('c25', !visible)
    }
  })

  root.querySelectorAll('#saleDeleted_form_sale_vs_item .line').forEach(line => {
    line.querySelector('.cost_vs_profit')?.closest('.dn_cost_vs_profit')?.classList.toggle('dn', !visible)
    line.querySelector('.returned_qty')?.closest('.dn_return')?.classList.toggle('dn', !visible)

    const itemName = line.querySelector('.itemname')
    const itemDetail = line.querySelector('.itemdetail')
    if (itemName) itemName.style.width = visible ? '25%' : '48%'
    if (itemDetail) itemDetail.style.width = visible ? '73%' : '50%'

    line.querySelectorAll('.itemdetail input').forEach(input => {
      const column = input.parentNode?.parentNode
      if (!column) return

      if (input.parentNode.classList.contains('qty')) {
        column.classList.toggle('c14', visible)
        column.classList.toggle('c25', !visible)
      } else if (!input.parentNode.classList.contains('cost_vs_profit')) {
        column.classList.toggle('c20', visible)
        column.classList.toggle('c25', !visible)
      }
    })

    fillCostField(line)
  })

  calculateGrandTotal(htmlFc)
}

export function showreturn(htmlFc) {
  const root = htmlFc.fullcontHTML
  const visible = Boolean(root.querySelector('#showreturn')?.checked)
  root.querySelector('#mt_return')?.classList.toggle('dn', !visible)

  calculateGrandTotalReturn(htmlFc)
}

function calculateGrandTotal(htmlFc) {
  const root = htmlFc.fullcontHTML
  let total = 0
  let totalProfit = 0
  let totalCost = 0

  root.querySelectorAll('#saleDeleted_form_sale_vs_item .line').forEach(line => {
    const qty = Number.parseFloat(line.querySelector('.qty input')?.value) || 0
    const price = Number.parseFloat(line.querySelector('.price input')?.value) || 0
    const cost = Number.parseFloat(line.querySelector('.cost input')?.value) || 0
    const selected = line.querySelector('.purchase_vs_itemId')?.getAttribute('selected')

    total += Number.parseFloat(line.querySelector('.total input')?.value) || 0

    try {
      if (selected && JSON.parse(selected).length) {
        totalCost += cost * qty
        totalProfit += (price * qty) - (cost * qty)
      }
    } catch (error) {
      // Ignore malformed selection metadata in the read-only view.
    }
  })

  const grandTotal = root.querySelector('#saleDeleted_form_grand_total input')
  const totalAmount = root.querySelector('#saleDeleted_form_total_amount input')
  const totalProfitPct = root.querySelector('#saleDeleted_form_total_profit_pct input')
  const totalReturn = Number.parseFloat(root.querySelector('#saleDeleted_form_total_return input')?.value) || 0
  const totalItemReturn = root.querySelector('#saleDeleted_form_total_item_return input')
  const profitPercentage = totalCost > 0 ? (totalProfit / totalCost) * 100 : 0

  if (grandTotal) grandTotal.value = total.toFixed(2)
  if (totalAmount) totalAmount.value = total.toFixed(2)
  if (totalProfitPct) totalProfitPct.value = `${totalProfit.toFixed(2)} / %${profitPercentage.toFixed(2)}`
  if (totalItemReturn) totalItemReturn.value = (total - totalReturn).toFixed(2)
}

function calculateGrandTotalReturn(htmlFc) {
  const root = htmlFc.fullcontHTML
  const totalReturn = Array.from(root.querySelectorAll('#saleDeleted_form_sale_vs_return .line'))
    .reduce((amount, line) => amount + (Number.parseFloat(line.querySelector('.lost_price input')?.value) || 0), 0)
  const totalAmount = Number.parseFloat(root.querySelector('#saleDeleted_form_total_amount input')?.value) || 0
  const grandTotalReturn = root.querySelector('#saleDeleted_form_grand_total_return input')
  const totalReturnField = root.querySelector('#saleDeleted_form_total_return input')
  const totalItemReturn = root.querySelector('#saleDeleted_form_total_item_return input')

  if (grandTotalReturn) grandTotalReturn.value = totalReturn.toFixed(2)
  if (totalReturnField) totalReturnField.value = totalReturn.toFixed(2)
  if (totalItemReturn) totalItemReturn.value = (totalAmount - totalReturn).toFixed(2)
}

function fillCostField(line) {
  const qty = Number.parseFloat(line.querySelector('.qty input')?.value) || 0
  const price = Number.parseFloat(line.querySelector('.price input')?.value) || 0
  const cost = Number.parseFloat(line.querySelector('.cost input')?.value) || 0
  const costProfit = line.querySelector('.cost_vs_profit input')
  const selected = line.querySelector('.purchase_vs_itemId')?.getAttribute('selected')

  if (!costProfit || !selected) return

  try {
    if (JSON.parse(selected).length) {
      costProfit.value = `${cost.toFixed(2)} / ${((price * qty) - (qty * cost)).toFixed(2)}`
    }
  } catch (error) {
    costProfit.value = ''
  }
}

export function fill_InventoryStock(data) {
  inventoryStock = []

  try {
    const parsed = JSON.parse(data.inventory_stock)
    const records = parsed?.[0]?.data
    if (Array.isArray(records)) inventoryStock = [...records]
  } catch (error) {
    inventoryStock = []
  }
}

export async function restoreSale(htmlFc) {
  if (restoringSale) return

  const saleId = htmlFc.fullcontHTML.getAttribute('data-dbid')
  if (!saleId) return

  const restoreButton = htmlFc.fullcontHTML.querySelector('.fab-restore > .green')
  const formData = new FormData()
  formData.append('sale_id', saleId)

  restoringSale = true
  if (restoreButton) restoreButton.style.pointerEvents = 'none'

  try {
    const response = await fetch('./server/php/queries/entityFunction/restoreSale.php', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    if (!response.ok) throw new Error(`HTTP ${response.status}`)

    const result = await response.json()
    const requestWasAuthorized = result.authentication?.val === 'ok' &&
      result.authorization?.val === 'ok'

    if (requestWasAuthorized && result.error?.val === 'inventoryConflict') {
      saleDeletedDialog.start({
        act: 'show',
        id: 'inventoryRestoreConflict',
        items: result.data
      })
      return
    }

    const restored = requestWasAuthorized && result.error?.val === 'ok'

    if (!restored) {
      return
    }

    const restoredSale = result.data?.[0]
    if (restoredSale) {
      restoredSale.dest = 'sale'
      websocket.entityUpdate('entityUpdate', 'addRow', restoredSale, {
        to: 'allStaff',
        from: 'staffDesktop',
        id: ''
      })
    }

    fullcontEntity.hide({ id: 'saleDeleted-fullcont' }, htmlFc)
    saleDeletedDt.start({ dest: 'saleDeleted', elem: 'dt', act: 'select', entity: 'saleDeleted' })
  } catch (error) {
    // Keep the deleted sale open when the restore request fails.
  } finally {
    restoringSale = false
    if (restoreButton) restoreButton.style.pointerEvents = ''
  }
}
